/* eslint-disable react/jsx-max-props-per-line */
/* eslint-disable react/jsx-sort-props */
import React, { useEffect, useMemo, useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
import { Grid } from '@mui/material';
import moment from 'moment';
import * as selectorsJornada from '../../../store/jornada/reducer';
import * as actionsJornada from '../../../store/jornada/actions';
import * as Role from '../../../constants/role';
import { JORNADA_ITEM_TIPOS } from '../../../constants/jornadaItemTipo';
import {
  DialogDefaultV2,
  InputV2,
  InputFormatV2,
  UsuarioSelectV2,
  OptionSelectV2,
  DatePickerV2,
  WidgetV2,
} from '../../../components/v2';
import { convertTimeToMinutes, formatToTime } from 'utils';
import {
  computeJornadaTotalMinutes,
  geoPointsFromItens,
  itensByTipo,
  timesFromItens,
} from '../../../helpers/jornadaHelpers';
import JornadaGeoLine from '../../../helpers/JornadaGeoLine';
import JornadaPontosMap from '../../../helpers/JornadaPontosMap';

const emptyValues = () => ({
  data: moment().valueOf(),
  tipoControle: 'CONTROLE_JORNADA',
  itens: [],
});

const Formulario = ({
  open,
  id,
  onClose,
  loadJornada,
  jornada,
}) => {
  const [values, setValues] = useState(emptyValues);
  const [openMapa, setOpenMapa] = useState(false);

  const byTipo = useMemo(() => itensByTipo(values.itens), [values.itens]);
  const pontos = useMemo(() => geoPointsFromItens(values.itens), [values.itens]);

  useEffect(() => {
    if (id) loadJornada(id);
  }, [id, loadJornada]);

  useEffect(() => {
    if (id && jornada && id === jornada.id) {
      const times = timesFromItens(jornada.itens);
      const totalMinutes = computeJornadaTotalMinutes(times, convertTimeToMinutes)
        || jornada.jornadaTotalMinutes;
      setValues({
        ...jornada,
        ...times,
        data: moment(parseInt(jornada.data, 10)).valueOf(),
        itens: jornada.itens || [],
        jornadaTotal: totalMinutes
          ? formatToTime(totalMinutes)
          : (jornada.jornadaTotal || null),
      });
    } else if (!id) {
      setValues(emptyValues());
    }
  }, [jornada, id]);

  const onCloseLocal = () => {
    setValues(emptyValues());
    setOpenMapa(false);
    onClose(false);
  };

  return (
    <DialogDefaultV2
      open={open}
      handlerCancel={onCloseLocal}
      handlerConfirm={onCloseLocal}
      title="Jornada Medição"
      maxWidth="md"
      fullWidth
      readOnly
    >
      <Grid container spacing={1} sx={{ mt: 0 }}>
        <Grid size={{ xs: 12, sm: 3 }}>
          <DatePickerV2
            label="Data"
            value={values.data}
            onChange={() => {}}
            disabled
          />
        </Grid>
        <Grid size={{ xs: 12, sm: 3 }}>
          <OptionSelectV2
            label="Tipo de Serviços"
            codigo="TIPO_SERVICO"
            value={values.tipoServico}
            onSelect={() => {}}
            disabled
          />
        </Grid>
        <Grid size={{ xs: 12, sm: 3 }}>
          <InputV2
            label="Cidade"
            name="cidade"
            value={values.cidade || ''}
            onChange={() => {}}
            disabled
          />
        </Grid>
        <Grid size={{ xs: 12, sm: 3 }}>
          <UsuarioSelectV2
            label="Inspetor"
            grupos={[Role.ADMIN, Role.INSPETOR]}
            value={values.inspetor}
            onSelect={() => {}}
            disabled
          />
        </Grid>
        <Grid size={{ xs: 12, sm: 3 }}>
          <UsuarioSelectV2
            label="Parceiro"
            grupos={[Role.ADMIN, Role.INSPETOR]}
            value={values.inspetorAuxiliar}
            onSelect={() => {}}
            disabled
          />
        </Grid>
        <Grid size={{ xs: 12 }}>
          <WidgetV2
            title="Horários"
            collapse={false}
            initialExpanded
            insideTab
            sxContent={{ p: 1.5 }}
            actions={[{
              title: 'Mapa',
              show: pontos.length > 0,
              onClick: () => setOpenMapa(true),
            }]}
          >
            <Grid container spacing={1}>
              {JORNADA_ITEM_TIPOS.map(({ tipo, timeField, label }) => (
                <Grid key={tipo} size={{ xs: 12, sm: 6 }}>
                  <InputFormatV2
                    label={label}
                    value={values[timeField]}
                    onChange={() => {}}
                    format="##:##"
                    placeholder="HH:MM"
                    disabled
                  />
                  <JornadaGeoLine
                    item={byTipo[tipo]}
                    fotoUrl={byTipo[tipo]?.foto?.url}
                  />
                </Grid>
              ))}
              <Grid size={{ xs: 12, sm: 6 }} sx={{ pb: 1.5 }}>
                <InputV2 label="Hora Total Trabalhada" disabled value={values.jornadaTotal || ''} />
              </Grid>
            </Grid>
          </WidgetV2>
        </Grid>
      </Grid>
      <JornadaPontosMap
        open={openMapa}
        onClose={() => setOpenMapa(false)}
        itens={values.itens}
      />
    </DialogDefaultV2>
  );
};

Formulario.propTypes = {
  open: PropTypes.bool.isRequired,
  id: PropTypes.string,
  onClose: PropTypes.func.isRequired,
  loadJornada: PropTypes.func.isRequired,
  jornada: PropTypes.object,
};

const mapStateToProps = (state) => ({
  jornada: selectorsJornada.getSelectedJornada(state),
});

const mapDispatchToProps = (dispatch) => bindActionCreators({
  ...actionsJornada,
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Formulario));
